import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductGlobalFieldsSettingsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-global-fields", jiraSpaEntry: "async-polaris-ideas" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
